import { combineReducers } from "redux"

import theme from "./slices/themeSlice"
import auth from "./slices/authSlice"
import consultation from "./slices/consultationsSlice"

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    auth,
    theme,
    consultation,
    ...asyncReducers,
  })
  return combinedReducer(state, action)
}

export default rootReducer
